import styled from '@emotion/styled/macro'
import { Proving, ProvingGround } from 'model'
import { IPivotProps, Pivot, PivotItem } from 'office-ui-fabric-react'
import * as React from 'react'

const StretchPivot = styled(Pivot)`
  .ms-Pivot {
    display: flex;
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .ms-Pivot-link {
    flex: 1;
    padding-left: 3px;
    padding-right: 3px;

    .ms-Button-flexContainer {
      justify-content: center;
    }
  }

  .ms-Pivot-text {
    font-weight: 600;
  }

  .ms-Pivot-link:first-of-type {
    flex: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export type DataStoragePaginationProps = Omit<
  IPivotProps,
  'selectedKey' | 'onLinkClick'
> & {
  selectedCategory: string
  proving: Proving
  provingGround: any
  onSelectCategory: (page: string) => void
}

export const DataStoragePagination: React.FC<DataStoragePaginationProps> = ({
  selectedCategory,
  onSelectCategory,
  proving,
  provingGround,
  ...props
}) => {
  const items: string[] = []
  const itemsFix: any[] = []
  let categories: any[] = []

  if (proving && proving.provingGround) {
    for (let i = 1; i <= 10; i++) {
      const block = proving.provingGround[`block${i}` as keyof ProvingGround]
      if (block) {
        items.push(block)
        categories.push({ key: `block${i}`, text: block })
      }
    }
  }

  itemsFix.push({ key: 'fix1', text: 'Hotelreservierungen' })
  if (!provingGround.hideFlight) {
    itemsFix.push({ key: 'fix3', text: 'Flugbestätigungen' })
  }
  itemsFix.push({ key: 'fix2', text: 'Mietwagenreservierungen' })
  if (!provingGround.hideFerryConnection) {
    itemsFix.push({ key: 'fix4', text: 'Fährreservierungen' })
  }
  if (!provingGround.hideHotels) {
    itemsFix.push({ key: 'fix5', text: 'Streckenhotelreservierungen' })
  }
  itemsFix.push({ key: `default`, text: 'Nicht zugewiesene Dokumente' })

  categories = categories.sort((a, b) =>
    a.text.localeCompare(b.text, 'de', {
      numeric: true,
    })
  )

  // const categoriesFix = [
  //   ...itemsFix.map((item: string, i) => ({
  //     key: `fix${i + 1}`,
  //     text: item,
  //   })),
  // ]

  // categoriesFix.push({ key: `default`, text: 'Nicht zugewiesene Dokumente' })

  const allCategories = categories.concat(itemsFix)

  const handleLinkClicked = React.useCallback(
    (link?: PivotItem) => {
      if (link) {
        onSelectCategory(link.props.itemKey!)
      }
    },
    [onSelectCategory]
  )

  return (
    <StretchPivot
      {...props}
      headersOnly={true}
      selectedKey={selectedCategory}
      onLinkClick={handleLinkClicked}
    >
      {allCategories.map((category) => (
        <PivotItem
          key={category.key}
          itemKey={category.key}
          headerText={category.text}
        />
      ))}
    </StretchPivot>
  )
}
